module.exports = __webpack_public_path__ + "static/media/19ESCAP20.c37dbe65.jpg";